var J = Object.defineProperty;
var Q = (e, t, r) => t in e ? J(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var d = (e, t, r) => Q(e, typeof t != "symbol" ? t + "" : t, r);
import A from "axios";
async function Se(e, t) {
  for (const r of e)
    await t(r);
  return !0;
}
function Fe(e, t, r = "items", n) {
  const i = {};
  let o;
  if (typeof t == "function")
    o = t;
  else if (typeof t == "string")
    o = (a) => a[t];
  else
    return console.debug("Invalid groupKey provided. Should be a string or a function", t), [];
  const s = typeof n == "function" ? (a, u) => n(a, u) : (a, u) => ({
    type: "group",
    name: u,
    [r]: [a]
  });
  return e.reduce((a, u) => {
    const l = o(u), m = l === "" || typeof l > "u" ? "other" : l;
    if (i[m] !== void 0) {
      const c = i[m];
      typeof c == "number" && a[c][r].push(u);
    } else
      i[m] = a.length, a.push(s(u, m));
    return a;
  }, []);
}
function Re(e) {
  if (Array.isArray(e) && e.length > 1) {
    let t = e.length;
    for (; t !== 0; ) {
      let r = Math.floor(Math.random() * t);
      t -= 1;
      let n = e[t];
      e[t] = e[r], e[r] = n;
    }
    return e;
  }
  return e;
}
function h(e, t) {
  return Object.entries(e).forEach(([r, n]) => {
    let i = typeof t[r];
    if (i === "object" && Array.isArray(t[r]) && (i = "array"), n.required && i === "undefined")
      throw new Error(`Missing required value: ${r}`);
    if (Array.isArray(n.types) && i !== "undefined" && !n.types.includes("any") && !n.types.includes(i))
      throw new Error(
        `Incorrect value type for: ${r}. Expected: ${n.types.join(
          ", "
        )}, got ${i}`
      );
  }), !0;
}
function Ce({
  data: e,
  sortKey: t,
  direction: r = "AZ"
}) {
  h({
    data: {
      required: !0,
      types: ["array"]
    },
    sortKey: {
      required: !0,
      types: ["string"]
    },
    direction: {
      required: !0,
      types: ["string"]
    }
  }, { data: e, sortKey: t, direction: r });
  const i = r === "ZA" ? 1 : -1;
  return e.sort((o, s) => o[t] < s[t] ? 1 * i : -1 * i), e;
}
function Ee({
  data: e,
  sortKey: t,
  order: r
}) {
  h({
    data: {
      required: !0,
      types: ["array"]
    },
    sortKey: {
      required: !0,
      types: ["string"]
    },
    order: {
      required: !0,
      types: ["array"]
    }
  }, { data: e, sortKey: t, order: r });
  const i = r.reduce((s, a, u) => (s[a] = u, s), {});
  function o(s) {
    return s && typeof i[s] == "number" ? i[s] : 999;
  }
  return e.sort(
    (s, a) => o(s[t]) - o(a[t])
  );
}
function Ue(e, t) {
  const r = e.indexOf(t), n = [...e];
  return r === -1 ? n.push(t) : n.splice(r, 1), n;
}
function Le(e, t) {
  return e && t.target && (e.contains(t.target) || e === t.target);
}
function Oe(e, t) {
  if (e && t) {
    const r = e.querySelector(t);
    r && (r.focus(), r.select());
  }
}
function Me(e) {
  q(e, "first");
}
function q(e, t = "first") {
  if (e) {
    const r = e.querySelectorAll("[tabindex]"), n = Array.from(r).filter(
      (i) => i.getAttribute("tabindex") !== "-1"
    );
    if (["first", "last"].includes(t)) {
      const i = n[t === "first" ? 0 : n.length - 1];
      i && i.focus();
    } else {
      const i = document == null ? void 0 : document.activeElement, o = i ? n.indexOf(i) : -1;
      if (o > -1) {
        const s = n[t === "next" ? o + 1 : o - 1];
        s && s.focus();
      } else
        q(e, "first");
    }
  }
}
function Pe(e) {
  return getComputedStyle(document.documentElement).getPropertyValue(e);
}
function j() {
  try {
    const e = "p5-services-check-localStorage";
    return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}
function Ae(e, t, r) {
  const n = e.replace("#", ""), i = t.replace("#", ""), o = parseInt(n.slice(0, 2), 16), s = parseInt(n.slice(2, 4), 16), a = parseInt(n.slice(4, 6), 16), u = parseInt(i.slice(0, 2), 16), l = parseInt(i.slice(2, 4), 16), m = parseInt(i.slice(4, 6), 16), c = (u - o) / (r - 1), f = (l - s) / (r - 1), y = (m - a) / (r - 1), w = [e];
  let _ = o, I = s, N = a;
  for (let S = 0; S < r - 2; S += 1) {
    _ += c, I += f, N += y;
    const G = Math.floor(_).toString(16), Z = Math.floor(I).toString(16), V = Math.floor(N).toString(16), X = `#${G.padStart(2, "0")}${Z.padStart(2, "0")}${V.padStart(2, "0")}`;
    w.push(X);
  }
  return w.push(t), w;
}
const qe = {
  d: {
    day: "numeric"
  },
  dd: {
    day: "2-digit"
  },
  "dd m": {
    day: "2-digit",
    month: "numeric"
  },
  "d mm": {
    day: "numeric",
    month: "2-digit"
  },
  "dd mm": {
    day: "2-digit",
    month: "2-digit"
  },
  "dd mm yyyy": {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  },
  "D d M": {
    weekday: "short",
    day: "numeric",
    month: "long"
  },
  "DD dd mm yyyy": {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  },
  "hh ii": {
    hour: "2-digit",
    minute: "2-digit"
  },
  "dd mm hh ii": {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  },
  "dd mm yyyy hh ii": {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  },
  "DD dd mm yyyy hh ii": {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }
};
function je(e = /* @__PURE__ */ new Date()) {
  e = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate())), e.setUTCDate(e.getUTCDate() + 4 - (e.getUTCDay() || 7));
  const t = new Date(Date.UTC(e.getUTCFullYear(), 0, 1));
  return Math.ceil(((e.getTime() - t.getTime()) / 864e5 + 1) / 7);
}
function He(e) {
  const t = /* @__PURE__ */ new Date(), r = e.reduce((n, i) => (Object.keys(n).includes(i.type) && (n[i.type] = +i.value), n), {
    day: void 0,
    month: void 0,
    year: void 0,
    hour: void 0,
    minute: void 0,
    seconds: 0
  });
  return r.day && t.setDate(r.day), r.month && t.setMonth(r.month - 1), r.year && t.setFullYear(r.year), r.hour && t.setHours(r.hour), r.minute && t.setMinutes(r.minute), r.seconds && t.setMinutes(r.seconds), t;
}
function Be(e = "Europe/Amsterdam") {
  try {
    return Intl.DateTimeFormat("ia", {
      timeZoneName: "short",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }).formatToParts();
  } catch {
    return !1;
  }
}
function Ke(e = /* @__PURE__ */ new Date(), t) {
  const r = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()));
  return r.setDate(r.getDate() + (t + 7 - r.getDay()) % 7), r;
}
function ze(e = /* @__PURE__ */ new Date(), t = !1, r = !1) {
  if (t) {
    const n = new Date(e.getTime());
    return r ? n.setUTCHours(0, 0, 0) : n.setHours(0, 0, 0), Math.floor(n.getTime() / 1e3);
  }
  return Math.floor(e.getTime() / 1e3);
}
function We(e) {
  if (typeof e != "number")
    return "";
  const t = Math.floor(e / 60), r = e % 60;
  return `${t}:${r < 10 ? "0" : ""}${r}`;
}
function H(e, t) {
  const r = [], n = new Date(e);
  for (; n <= t; )
    r.push(new Date(n)), n.setDate(n.getDate() + 1);
  return r;
}
function ee(e, t, r) {
  const n = e <= 9999999999, i = new Date(n ? e * 1e3 : e), o = new Date(n ? t * 1e3 : t);
  return typeof r == "number" && (i.setHours(r, 0, 0, 0), o.setHours(r, 0, 0, 0)), H(i, o).map((a) => {
    const u = a.getTime();
    return n ? Math.floor(u / 1e3) : u;
  });
}
function Ye(e, t, r, n, i) {
  const o = typeof e == "number" ? ee : H;
  return e <= r && r <= t ? o(r, t < n ? t : n, i) : e <= n && n <= t ? o(e, n, i) : r < e && t < n ? o(e, t, i) : [];
}
function Ge(e) {
  e.sort((t, r) => t.getTime() - r.getTime());
}
function F(e, t) {
  switch (e || t) {
    case "-":
    case "ago":
    case "last":
    case "previous":
      return -1;
    case "this":
      return 0;
    case "+":
    case "in":
    case "next":
    default:
      return 1;
  }
}
const te = {
  yesterday: {
    regex: /^yesterday/i,
    example: "yesterday",
    callback(e) {
      return e.setDate(e.getDate() - 1), e;
    }
  },
  today: {
    regex: /^today|now/i,
    example: "today | now",
    callback(e) {
      return e;
    }
  },
  tomorrow: {
    regex: /^tomorrow/i,
    example: "tomorrow",
    callback(e) {
      return e.setDate(e.getDate() + 1), e;
    }
  },
  midnight: {
    regex: /^midnight/i,
    example: "midnight | yesterday midnight",
    callback(e) {
      return e.setHours(0, 0, 0, 0), e;
    }
  },
  specificDate: {
    regex: /^(?<month>january|february|march|april|may|june|july|august|september|october|november|december)\s+(?<day>\d+)(?:st|nd|rd|th)?/i,
    example: "january 1st | march 28 | april 3rd",
    callback: (e, { groups: t }) => {
      const r = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"].indexOf(t.month.toLowerCase()), n = parseInt(t.day, 10);
      return e.setMonth(r, n), e;
    }
  },
  relativeText: {
    regex: /^(?<direction>\+|-|in)?(?:\s|and)*(?:(?<years>\d+) years?)?(?:\s|and)*(?:(?<months>\d+) months?)?(?:\s|and)*(?:(?<weeks>\d+) weeks?)?(?:\s|and)*(?:(?<days>\d+) days?)?(?:\s|and)*(?:(?<hours>\d+) hours?)?(?:\s+|and)*(?:(?<minutes>\d+) minutes?)?(?:\s|and)*(?:(?<seconds>\d+) seconds?)?(?:\s)*(?<ago>ago)?/i,
    example: "in 2 days and 4 hours | 1 week 2 days 4 hours 2 minutes 3 seconds ago | + 2 days | - 1 month 2 weeks",
    callback(e, { groups: t }) {
      const r = F(t.direction, t.ago), n = {
        years: {
          functionName: "FullYear",
          multiplier: 1
        },
        months: {
          functionName: "Month",
          multiplier: 1
        },
        weeks: {
          functionName: "Date",
          multiplier: 7
        },
        days: {
          functionName: "Date",
          multiplier: 1
        },
        hours: {
          functionName: "Hours",
          multiplier: 1
        },
        minutes: {
          functionName: "Minutes",
          multiplier: 1
        },
        seconds: {
          functionName: "Seconds",
          multiplier: 1
        }
      };
      return Object.keys(n).forEach((i) => {
        if (t[i] && i in n) {
          const o = n[i], s = o.functionName;
          e[`set${s}`](e[`get${s}`]() + r * o.multiplier * parseInt(t[i], 10));
        }
      }), e;
    }
  },
  weekdayOf: {
    regex: /^(?<direction>next|last)\s*(?<weekday>monday|tuesday|wednesday|thursday|friday|saturday|sunday)/i,
    example: "next monday | last friday",
    callback(e, { groups: t }) {
      const r = F(t.direction), n = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].indexOf(t.weekday.toLowerCase()), i = e.getDay(), o = n - i;
      let s = (7 * r + o) % 7;
      return s === 0 && (s = 7 * r), e.setDate(e.getDate() + s), e;
    }
  }
};
function Ze(e, t = /* @__PURE__ */ new Date()) {
  const r = new Date(t.getTime());
  let n = null, i = null;
  for (; e.length; ) {
    if (Object.values(te).forEach((o) => {
      const s = e.match(o.regex);
      s && (!n || s[0].length > n[0].length) && (n = s, i = o);
    }), !i || !n)
      return r;
    i.callback(r, n), e = e.substring(n[0].length).trim(), n = null, i = null;
  }
  return r;
}
function Ve(e, t = []) {
  const r = ["/", ...t];
  return Object.entries(e).reduce((n, [i, o]) => {
    var a, u;
    if (r.includes(i) || typeof o == "string" || typeof o == "boolean") return n;
    const s = "link" in o[0] ? o[0].link : (u = (a = o[0].items) == null ? void 0 : a[0]) == null ? void 0 : u.link;
    return s && n.push({
      text: i.replace(/\//g, ""),
      link: s
    }), n;
  }, []);
}
async function Xe(e, t) {
  const r = await K(t, e);
  return re(r, e);
}
function B(e, t, r = 1) {
  return t.type === "file" ? [] : t.contents.reduce((n, i) => {
    if (i.type === "file")
      n.push({
        text: i.name.toLowerCase() === "index" ? "Home" : i.name,
        link: i.path.replace(e, "")
      });
    else if (i.type === "folder") {
      const o = B(e, i, r + 1), s = o.find((u) => {
        var l;
        return ((l = u.text) == null ? void 0 : l.toLowerCase()) === "home";
      }), a = o.filter((u) => {
        var l;
        return ((l = u.text) == null ? void 0 : l.toLowerCase()) !== "home";
      });
      n.push({
        text: i.name,
        link: s == null ? void 0 : s.link,
        collapsed: a.length ? r > 1 : void 0,
        items: a.length ? a : void 0
      });
    }
    return n;
  }, []);
}
function re(e, t) {
  const r = {}, n = [];
  return e.forEach((i) => {
    if (i.type === "folder") {
      const o = B(t, i);
      o.length && (r[`/${i.name}/`] = o);
    } else
      n.push({
        text: i.name.toLowerCase() === "index" ? "Home" : i.name,
        link: i.path.replace(t, "")
      });
  }), n.length && (r["/"] = [{
    text: "",
    collapsed: !1,
    items: n
  }]), r;
}
async function K(e, t, r = [".md"]) {
  const n = [], i = await e(t, { withFileTypes: !0 });
  for (const o of i) {
    if (o.name.startsWith(".")) continue;
    const s = ge(o.name.replace(/^\d+-/, "").replace(/-/g, " "));
    if (o.isDirectory())
      n.push({
        name: s,
        type: "folder",
        contents: await K(e, `${t}${o.name}/`, r)
      });
    else {
      const a = o.name.slice(o.name.lastIndexOf("."));
      r.includes(a) && n.push({
        name: s.replace(a, ""),
        type: "file",
        path: `${t}${o.name}`
      });
    }
  }
  return n;
}
const Je = function() {
  if (typeof document < "u") {
    const t = document.createElement("a");
    return document.body.appendChild(t), t.style.display = "none", function(n, i) {
      const o = new Blob([n], { type: "octet/stream" }), s = window.URL.createObjectURL(o);
      t.href = s, t.download = i, t.click(), window.URL.revokeObjectURL(s);
    };
  }
}();
function ne(e) {
  const t = {
    k: 1,
    m: 2,
    g: 3,
    t: 4
  }, n = /(\d+(?:\.\d+)?)\s?(k|m|g|t)?b?/i.exec(e);
  return n[1] * 1024 ** t[n[2].toLowerCase()];
}
function ie(e, t = []) {
  return !t.length || t.includes(e.type.toLowerCase());
}
function oe(e, t = []) {
  const r = typeof e.name == "string" ? e.name.toLowerCase() : e.name;
  return !t.length || t.some((n) => r.endsWith(n.toLowerCase()));
}
function se(e, t) {
  return t && e.size ? e.size < ne(t) : !0;
}
function ae(e, t) {
  return t && t.length ? t[0].includes("/") ? ie(e, t) : oe(e, t) : !0;
}
function $(e, t) {
  if (typeof e != "object")
    throw new Error("Invalid file object");
  if (t.maxFilesize && !se(e, t.maxFilesize))
    throw new Error("File too large");
  if (t.allowed && !ae(e, t.allowed))
    throw new Error("File type not allowed");
  return !0;
}
async function Qe(e, t = {}) {
  e.preventDefault();
  const r = { allowed: [], ...t }, n = [];
  let i = null;
  switch (e.type) {
    case "drop":
      i = e.dataTransfer;
      break;
    case "paste":
      i = e.clipboardData;
      break;
  }
  if (i)
    if (i.items) {
      for (let o = 0; o < i.items.length; o += 1)
        if (i.items[o].kind === "file") {
          const s = i.items[o].getAsFile();
          s && $(s, r) && n.push(s);
        }
    } else
      for (let o = 0; o < i.files.length; o += 1)
        $(i.files[o], r) && n.push(i.files[o]);
  if (n.length)
    return n;
  throw new Error("No files dropped");
}
function et(e, t = {}) {
  return new Promise((r, n) => {
    const i = { max: 0, allowed: [], ...t }, o = e.files;
    if (!o)
      n(new Error("No file selected"));
    else {
      const s = Object.values(o).reduce((a, u) => ($(u, i) && a.push(u), a), []);
      !s || s.length < 1 ? n(new Error("No file selected")) : i.max !== 0 && s.length > i.max ? n(new Error("Too many files")) : r(s);
    }
  });
}
function tt(e) {
  const t = {
    path: e,
    extension: "",
    filename: "",
    folder: "",
    prettyfilename: "",
    created: 0,
    query: ""
  };
  let r = "", n = "fake-path.com";
  e.startsWith("https://") ? r = "https://" : e.startsWith("http://") && (r = "http://");
  const i = new URL(r ? e : `https://${n}/${e}`);
  t.path = `${i.hostname.replace(n, "")}${i.pathname}`, t.query = i.search;
  const o = t.path.split("/").filter((l) => l), s = o[o.length - 1];
  s.indexOf(".") > -1 && (t.extension = s.split(".").pop() || ""), t.filename = o.pop() || "", t.folder = `${r}${o.join("/")}/`, t.query.indexOf("hash=") > -1 && (t.filename = `Encrypted file${t.extension ? `.${t.extension}` : ""}`, t.path += t.query);
  let a = t.filename.replace(`.${t.extension}`, "");
  const u = a.substring(0, 10);
  return Number.isNaN(+u) || (a = a.substring(11), t.created = +u), a = a.replace(/_/g, " "), t.prettyfilename = a, t.path = `${r}${t.path}`, t.path.startsWith("/") && (t.path = t.path.substring(1)), t;
}
function rt(e, t) {
  let r;
  return (...n) => (r && clearTimeout(r), new Promise((i) => {
    r = setTimeout(() => {
      const o = e(...n);
      i(o);
    }, t);
  }));
}
async function ue(e, t, r) {
  const n = [], i = [];
  return e.forEach((o) => {
    typeof o == "string" ? i.push(W(o, r)) : (o.endpoint || o.data) && n.push(le(o, t, r));
  }), await Promise.all(n).then((o) => {
    o.forEach((s) => {
      i.push(...s);
    });
  }).catch(console.error), i;
}
function le(e, t, r) {
  return new Promise((n, i) => {
    e.data ? n(R(e.data.results, e, r)) : t.get(e.endpoint).then(({ status: o, data: s }) => {
      o === 200 && s.status === "success" ? n(R(s.results, e, r)) : i(new Error("invalid response"));
    }).catch(i);
  });
}
function R(e, { path: t, langPath: r }, n) {
  return e.reduce((i, o) => {
    if (t) {
      const s = t(o);
      s && (typeof s == "string" ? i.push(W(s, n)) : i.push(g({ page: s.main || "", alternateLangs: s, settings: n })));
    } else if (r) {
      const s = r(o, n.language, n.languages);
      s && i.push(g({ page: s.main || "", alternateLangs: s, settings: n }));
    }
    return i;
  }, []);
}
let z;
function C(e, t) {
  return e.replace(z, `/${t ? `${t}/` : ""}`);
}
function W(e, t) {
  if (t.languages.length <= 1)
    return g({ page: e, settings: t });
  if (t.languageMode === "query") {
    const r = e, n = {};
    return t.languages.forEach((i) => {
      n[i] = `${e}${e.includes("?") ? "&" : "?"}lang=${i}`;
    }), g({ page: r, alternateLangs: n, settings: t });
  } else {
    const r = C(e), n = {};
    return t.languages.forEach((i) => {
      n[i] = C(e, i);
    }), g({ page: r, alternateLangs: n, settings: t });
  }
}
function E(e, t) {
  return t.startsWith("http") ? t : `${e}${t}`;
}
function g({
  page: e,
  alternateLangs: t = {},
  settings: r,
  changefreq: n = "daily",
  priority: i = 0.8
}) {
  return `
        <url>
            <loc>${E(r.baseUrl, e)}</loc>
            ${Object.entries(t).map(([o, s]) => o === "main" ? void 0 : `<xhtml:link rel="alternate" hreflang="${o}" href="${E(r.baseUrl, s)}" />`).filter((o) => o).join(`
`)}
            <changefreq>${n}</changefreq>
            <priority>${i}</priority>
        </url>
    `;
}
async function nt(e, t) {
  const r = A.create({
    baseURL: `${t.apiUrl}`,
    headers: {
      Authorization: `Bearer ${t.apiToken}`,
      namespace: `${t.apiNamespace}`
    }
  });
  z = new RegExp(`/${t.language}(?:$|/)`);
  const i = [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<urlset xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd http://www.w3.org/1999/xhtml http://www.w3.org/2002/08/xhtml/xhtml1-strict.xsd" xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml" >',
    ...await ue(e, r, t),
    "</urlset>"
  ];
  return {
    statusCode: 200,
    headers: { "Content-Type": "text/xml" },
    body: i.join(`
`)
  };
}
const v = /* @__PURE__ */ new Map();
function ce(e, t) {
  const r = e.name;
  if (!r) return e;
  const n = v.get(r);
  n == null || n.cancel("canceled by next request");
  const i = t.CancelToken.source();
  return v.set(r, i), e.cancelToken = i.token, e;
}
function U({ name: e }) {
  e && v.delete(e);
}
function it(e, t) {
  e.interceptors.request.use((r) => ce(r, t)), e.interceptors.response.use(
    (r) => (U(r.config), r),
    (r) => (r != null && r.config && U(r.config), Promise.reject(r))
  );
}
function ot(e, {
  maintenancePath: t = "",
  responseVersion: r = 1
}) {
  e.interceptors.response.use(
    (n) => r === 2 ? n : (typeof n.data == "object" && (n.data.statusCode = n.status), n.data),
    (n) => {
      var i, o, s;
      if (((i = n == null ? void 0 : n.response) == null ? void 0 : i.status) === 503 && ((s = (o = n == null ? void 0 : n.response) == null ? void 0 : o.data) == null ? void 0 : s.code) === 7) {
        const a = window.location.host, u = new URL(`${a}/${t}`);
        return u.searchParams.set("u", JSON.stringify(n.response.data.data || {})), window.location.pathname.includes(`/${t}`) || (window.location.href = u.toString().replace(a, "")), !1;
      }
      return Promise.reject(n);
    }
  );
}
const me = "https://europe-west1-blixem.cloudfunctions.net/corsprox";
class st {
  constructor({
    dataCenter: t,
    userID: r,
    listID: n,
    http: i
  }) {
    d(this, "dataCenter");
    d(this, "userID");
    d(this, "listID");
    d(this, "http");
    h({
      dataCenter: {
        required: !0,
        types: ["string"]
      },
      userID: {
        required: !0,
        types: ["string"]
      },
      listID: {
        required: !0,
        types: ["string"]
      },
      http: {
        required: !0,
        types: ["any"]
      }
    }, {
      dataCenter: t,
      userID: r,
      listID: n,
      http: i
    }), this.dataCenter = t, this.userID = r, this.listID = n, this.http = i;
  }
  subscribeUrl(t = {}) {
    const r = {
      u: this.userID,
      id: this.listID,
      ...t
    };
    let n = new URLSearchParams(r).toString();
    return n && (n = `?${n}`), `https://name.${this.dataCenter}.list-manage.com/subscribe/post-json${n}`;
  }
  /* istanbul ignore next */
  subscribe({ ...t }) {
    return new Promise((r, n) => {
      const i = this.subscribeUrl(t);
      try {
        this.http({
          url: me,
          headers: {
            "target-url": i
          }
        }).then(r).catch(n);
      } catch (o) {
        n(o);
      }
    });
  }
}
const b = "https://europe-west1-blixem.cloudfunctions.net/corsprox";
class at {
  constructor({
    apiURL: t,
    apiToken: r,
    endpoint: n = "contacts",
    http: i
  }) {
    d(this, "url");
    d(this, "token");
    d(this, "endpoint");
    d(this, "http");
    d(this, "getData", (t) => {
      const r = ["email", "firstName", "lastName", "phone"];
      return Object.entries(t).reduce(
        (n, [i, o]) => (r.includes(i) ? n[i] = o : n.fieldValues.push({
          field: typeof i == "number" ? i.toString() : i,
          value: o
        }), n),
        {
          fieldValues: []
        }
      );
    });
    d(this, "validateData", (t) => !!t.email);
    h({
      apiURL: {
        required: !0,
        types: ["string"]
      },
      apiToken: {
        required: !0,
        types: ["string"]
      },
      endpoint: {
        required: !0,
        types: ["string"]
      },
      http: {
        required: !0,
        types: ["any"]
      }
    }, {
      apiURL: t,
      apiToken: r,
      endpoint: n,
      http: i
    }), this.url = t, this.token = r, this.endpoint = n, this.http = i;
  }
  /* istanbul ignore next */
  subscribe(t) {
    return new Promise((r, n) => {
      this.validateData(t) || n(new Error("email is required"));
      const i = { contact: this.getData(t) };
      this.http({
        method: "POST",
        headers: {
          "Api-Token": this.token,
          "target-url": `${this.url}/${this.endpoint}/`
        },
        url: b,
        data: i
      }).then((o) => {
        o.status === 201 ? r(o.data) : n(new Error(`Invalid responsecode: ${o.status}`));
      }).catch((o) => {
        o.response && o.response.status === 422 ? r(i) : n(o);
      });
    });
  }
  /**
   * creates or updates contact based on emailaddress
   * @returns Promise with contactID
   */
  syncContact(t) {
    return new Promise((r, n) => {
      t.email ? this.http({
        method: "POST",
        headers: {
          "Api-Token": this.token,
          "target-url": `${this.url}/contact/sync/`
        },
        url: b,
        data: {
          contact: this.getData(t)
        }
      }).then((i) => {
        [200, 201].includes(i.status) ? r(i.data.contact.id) : (console.error(i), n(new Error(`Invalid responsecode: ${i.status}`)));
      }).catch((i) => {
        console.error(i), n(i);
      }) : n(new Error("email is required"));
    });
  }
  /**
   * adds pre-existing tag to contact
   */
  addContactTag(t, r) {
    return new Promise((n, i) => {
      !t || !r ? i(new Error("Invalid parameters. contactID and tagID are required")) : typeof t != "string" && typeof r != "string" ? i(new Error("contactID and tagID should be strings")) : this.http({
        method: "POST",
        headers: {
          "Api-Token": this.token,
          "target-url": `${this.url}/contactTags/`
        },
        url: b,
        data: {
          contactTag: {
            contact: t,
            tag: r
          }
        }
      }).then((o) => {
        if ([200, 201].includes(o.status))
          n(o.data.contactTag);
        else {
          console.error(o.data);
          try {
            console.error(JSON.stringify(o.data));
          } catch {
          }
          i(new Error(`Invalid responsecode: ${o.status}`));
        }
      }).catch((o) => {
        console.error(o), i(o);
      });
    });
  }
}
function L(e) {
  return e * 180 / Math.PI;
}
function O(e) {
  return e * Math.PI / 180;
}
function ut(e) {
  if (!e.length)
    return { lat: 0, lng: 0 };
  let t = 0, r = 0, n = 0;
  e.forEach((m) => {
    const c = O(m.lat), f = O(m.lng);
    t += Math.cos(c) * Math.cos(f), r += Math.cos(c) * Math.sin(f), n += Math.sin(c);
  });
  const i = t / e.length, o = r / e.length, s = n / e.length, a = Math.atan2(o, i), u = Math.sqrt(i * i + o * o), l = Math.atan2(s, u);
  return { lat: L(l), lng: L(a) };
}
function lt(e, t) {
  var n;
  let r = "https://www.google.com/maps/search/?api=1";
  return (e.name || t) && (r += `&query=${encodeURIComponent(e.name || t || "naam")}`), e != null && e.place_id ? `${r}&query_place_id=${e.place_id}` : (n = e.coords) != null && n.lat ? `${r}&query=${e.coords.lat},${e.coords.lng}` : e.formatted ? `${r}&query=${encodeURIComponent(e.formatted)}` : r;
}
function ct(e) {
  var n, i;
  const t = "https://maps.googleapis.com/maps/api/staticmap", r = {
    size: e.size || "512x512",
    scale: e.scale || 2,
    zoom: e.zoom || 10,
    center: e.center || (n = e.coords) != null && n.lat ? `${e.coords.lat},${e.coords.lng}` : "0,0",
    markers: e.markers || (i = e.coords) != null && i.lat ? `${e.coords.lat},${e.coords.lng}` : "0,0",
    format: "png",
    key: e.key
  };
  return `${t}?${Object.entries(r).map(([o, s]) => `${o}=${s}`).join("&")}`;
}
function de() {
  const e = ["AUD", "BGN", "BRL", "CAD", "CHF", "CNY", "CZK", "DKK", "EUR", "GBP", "HKD", "HRK", "HUF", "IDR", "ILS", "INR", "ISK", "JPY", "KRW", "MXN", "MYR", "NOK", "NZD", "PHP", "PLN", "RON", "RUB", "SEK", "SGD", "THB", "TRY", "USD", "ZAR"];
  let t = "narrowSymbol";
  try {
    new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", currencyDisplay: t }).format(12.25);
  } catch {
    t = "symbol";
  }
  return e.reduce((r, n) => (r[n] = { style: "currency", currency: n, currencyDisplay: t }, r), {});
}
function mt() {
  return {
    ...de(),
    "decimals-0": {
      style: "decimal",
      maximumFractionDigits: 0
    },
    "decimals-1": {
      style: "decimal",
      maximumFractionDigits: 1
    },
    "decimals-2": {
      style: "decimal",
      maximumFractionDigits: 2
    },
    "decimals-3": {
      style: "decimal",
      maximumFractionDigits: 3
    },
    "decimals-1-all": {
      style: "decimal",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    },
    "decimals-2-all": {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    "decimals-3-all": {
      style: "decimal",
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    }
  };
}
function dt(e, t, r = 1, n = []) {
  const i = [];
  for (let o = e; o <= t; o += r)
    n.includes(o) || i.push(o);
  return i;
}
function ft(e, t = 0) {
  const r = Number(e);
  if (Number.isNaN(r))
    return console.debug("[Round Number] Value is not a number type:", e), e;
  const n = 10 ** t;
  return Math.round(r * n) / n;
}
function pt(e, t = 1) {
  const r = e + t / 2;
  return r - r % t;
}
function yt(e, t) {
  return t.reduce((r, n) => Math.abs(n - e) < Math.abs(r - e) ? n : r, t[0]);
}
function M(e) {
  return ["string", "number"].includes(typeof e) && e !== "";
}
function gt(e = "", t = {}) {
  if (Object.keys(t).length) {
    if (e) {
      const n = new URL(e);
      return Object.entries(t).forEach(([i, o]) => {
        M(o) ? n.searchParams.set(i, o) : Array.isArray(o) && o.forEach((s) => {
          M(s) && n.searchParams.append(i, s);
        });
      }), n.toString();
    }
    return `${new URLSearchParams(t).toString()}`;
  }
  return e;
}
function ht(e) {
  if (typeof (window == null ? void 0 : window.btoa) == "function")
    return window.btoa(encodeURIComponent(e));
  if (typeof Buffer == "function")
    return Buffer.from(e).toString("base64");
  throw new Error("encode base64 function not available");
}
function wt(e) {
  if (typeof (window == null ? void 0 : window.atob) == "function")
    return decodeURIComponent(window.atob(e));
  if (typeof Buffer == "function")
    return Buffer.from(e, "base64").toString("ascii");
  throw new Error("decode base64 function not available");
}
function bt(e, t = "==", r = "<strong>", n = "</strong>") {
  return typeof e == "string" ? e.split(t).map((o, s) => s % 2 === 0 ? o : `${r}${o}${n}`).join("") : e;
}
let p;
const fe = {
  area: {
    options: [{ id: "m2", label: "m2" }, { id: "ft2", label: "ft2" }],
    conversions: {
      m2: {
        ft2: { operator: "multiply", value: 10.764 }
      },
      ft2: {
        m2: { operator: "divide", value: 10.764 }
      }
    }
  },
  currency: {
    options: [{ id: "AUD", label: "AUD" }, { id: "AED", label: "AED" }, { id: "BGN", label: "BGN" }, { id: "BRL", label: "BRL" }, { id: "CAD", label: "CAD" }, { id: "CHF", label: "CHF" }, { id: "CNY", label: "CNY" }, { id: "CZK", label: "CZK" }, { id: "DKK", label: "DKK" }, { id: "EUR", label: "EUR" }, { id: "GBP", label: "GBP" }, { id: "HKD", label: "HKD" }, { id: "HUF", label: "HUF" }, { id: "IDR", label: "IDR" }, { id: "ILS", label: "ILS" }, { id: "INR", label: "INR" }, { id: "ISK", label: "ISK" }, { id: "JPY", label: "JPY" }, { id: "KRW", label: "KRW" }, { id: "MXN", label: "MXN" }, { id: "MYR", label: "MYR" }, { id: "NOK", label: "NOK" }, { id: "NZD", label: "NZD" }, { id: "PHP", label: "PHP" }, { id: "PLN", label: "PLN" }, { id: "RON", label: "RON" }, { id: "SEK", label: "SEK" }, { id: "SGD", label: "SGD" }, { id: "THB", label: "THB" }, { id: "TRY", label: "TRY" }, { id: "USD", label: "USD" }, { id: "ZAR", label: "ZAR" }],
    async conversions(e, t, r) {
      if (t && r) {
        if (t === r)
          return e;
        if (!(p != null && p.EUR)) {
          const { data: n } = await A.get("https://cdn.blixem.app/currencies/latest_currencies.json").catch(() => ({ data: void 0 }));
          (n == null ? void 0 : n.EUR) === 1 && (p = n);
        }
        return !p[t] || !p[r] ? -1 : (t !== "EUR" && (e = e / p[t]), r !== "EUR" && (e = e * p[r]), e);
      }
      return -1;
    }
  },
  distance: {
    options: [
      { id: "ft", label: "ft" },
      { id: "in", label: "in" },
      { id: "yd", label: "yd" },
      { id: "mi", label: "mi" },
      { id: "mm", label: "mm" },
      { id: "cm", label: "cm" },
      { id: "m", label: "m" },
      { id: "km", label: "km" }
    ],
    conversions: {
      ft: {
        in: { operator: "multiply", value: 12 },
        yd: { operator: "multiply", value: 0.33333 },
        mi: { operator: "multiply", value: 18939e-8 },
        mm: { operator: "divide", value: 32808e-7 },
        cm: { operator: "divide", value: 0.032808 },
        m: { operator: "divide", value: 3.2808 },
        km: { operator: "divide", value: 3280.8 }
      },
      in: {
        ft: { operator: "multiply", value: 0.083333 },
        yd: { operator: "multiply", value: 0.027778 },
        mi: { operator: "multiply", value: 15783e-9 },
        mm: { operator: "divide", value: 0.03937 },
        cm: { operator: "divide", value: 0.3937 },
        m: { operator: "divide", value: 39.37 },
        km: { operator: "divide", value: 39370 }
      },
      yd: {
        ft: { operator: "multiply", value: 3 },
        in: { operator: "multiply", value: 36 },
        mi: { operator: "multiply", value: 56818e-8 },
        mm: { operator: "divide", value: 10936e-7 },
        cm: { operator: "divide", value: 0.010936 },
        m: { operator: "divide", value: 1.0936 },
        km: { operator: "divide", value: 1093.6 }
      },
      mi: {
        ft: { operator: "multiply", value: 5280 },
        in: { operator: "multiply", value: 63360 },
        yd: { operator: "multiply", value: 1760 },
        mm: { operator: "divide", value: 62137e-11 },
        cm: { operator: "divide", value: 62137e-10 },
        m: { operator: "divide", value: 62137e-8 },
        km: { operator: "divide", value: 0.62137 }
      },
      mm: {
        ft: { operator: "multiply", value: 32808e-7 },
        in: { operator: "multiply", value: 0.03937 },
        yd: { operator: "multiply", value: 10936e-7 },
        mi: { operator: "divide", value: 62137e-11 },
        cm: { operator: "divide", value: 10 },
        m: { operator: "divide", value: 1e3 },
        km: { operator: "divide", value: 1e6 }
      },
      cm: {
        ft: { operator: "multiply", value: 0.032808 },
        in: { operator: "multiply", value: 0.3937 },
        yd: { operator: "multiply", value: 0.010936 },
        mi: { operator: "divide", value: 62137e-10 },
        mm: { operator: "divide", value: 0.1 },
        m: { operator: "divide", value: 100 },
        km: { operator: "divide", value: 1e5 }
      },
      m: {
        ft: { operator: "multiply", value: 3.2808 },
        in: { operator: "multiply", value: 39.37 },
        yd: { operator: "multiply", value: 1.0936 },
        mi: { operator: "multiply", value: 62137e-8 },
        mm: { operator: "multiply", value: 1e3 },
        cm: { operator: "multiply", value: 100 },
        km: { operator: "divide", value: 1e3 }
      },
      km: {
        ft: { operator: "multiply", value: 3280.8 },
        in: { operator: "multiply", value: 39370 },
        yd: { operator: "multiply", value: 1093.6 },
        mi: { operator: "multiply", value: 0.62137 },
        mm: { operator: "multiply", value: 1e6 },
        cm: { operator: "multiply", value: 1e5 },
        m: { operator: "multiply", value: 1e3 }
      }
    }
  }
};
async function xt(e, t, r, n) {
  if (typeof e == "number") {
    const i = fe[n].conversions;
    if (typeof i == "function")
      return i(e, t, r);
    const o = i[t] && i[t][r] ? i[t][r] : void 0;
    if (o)
      switch (o.operator) {
        case "divide":
          return e / o.value;
        case "multiply":
          return e * o.value;
        case "add":
          return e + o.value;
        case "subtract":
          return e - o.value;
      }
  }
  return e;
}
function Dt(e) {
  return !e || typeof e != "string" ? !1 : pe(e) || ye(e) || !1;
}
function pe(e) {
  const t = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/, r = e.match(t);
  return r && r[7] ? {
    type: "youtube",
    id: r[7],
    src: `https://www.youtube.com/embed/${r[7]}`
  } : !1;
}
function ye(e) {
  const t = /(?:http|https)?:?\/?\/?(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/, r = e.match(t);
  return r && r[1] ? {
    type: "vimeo",
    id: r[1],
    src: `https://player.vimeo.com/video/${r[1]}`
  } : !1;
}
function $t(e, t = 2) {
  return typeof e == "string" && e ? e.split(" ").reduce((r, n) => r.length < t ? `${r}${n[0]}` : r, "") : "";
}
function ge(e) {
  return e && typeof e == "string" ? e[0].toUpperCase() + e.slice(1) : e;
}
function vt(e, t, r = {}) {
  const n = "nl", i = "EUR";
  try {
    switch (t) {
      case "price":
        return new Intl.NumberFormat(r.lang || n, {
          style: "currency",
          currency: r.currency || i,
          currencyDisplay: "code",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(+e).replace(r.currency || i, "").trim();
      case "price_currency":
        return new Intl.NumberFormat(r.lang || n, {
          style: "currency",
          currency: r.currency || i,
          currencyDisplay: "narrowSymbol"
        }).format(+e);
      default:
        return e;
    }
  } catch (o) {
    return console.error(o), e;
  }
}
function Tt() {
  return `${Math.random().toString(36).slice(-8)}${Math.random().toString(36).slice(-8)}`;
}
function kt(e, t, r, n, i) {
  if (e && t && r) {
    const o = e[`${t}_${r}`];
    if (typeof o < "u" && (!i || o))
      return o;
    if (i && typeof e[`${t}_${i}`] < "u")
      return e[`${t}_${i}`];
  }
  return n || "";
}
function _t(e = "") {
  return typeof e == "string" ? e.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br />$2") : e;
}
function It(e, t) {
  return h({
    val: {
      required: !0,
      types: ["string"]
    },
    data: {
      required: !0,
      types: ["object"]
    }
  }, { val: e, data: t }), Object.keys(t).forEach((n) => {
    e.includes(`[${n}]`) && (e = e.replace(`[${n}]`, t[n]));
  }), e;
}
function Nt(e, t) {
  return e.split("/").reduce((i, o) => {
    if (o.startsWith(":")) {
      const s = o.substring(1);
      t[s] && i.push(t[s]);
    } else
      i.push(o);
    return i;
  }, []).join("/");
}
function St(e) {
  let t = 0;
  if (!e || typeof e != "string") return t;
  const r = {};
  for (let o = 0; o < e.length; o += 1)
    r[e[o]] = (r[e[o]] || 0) + 1, t += 5 / r[e[o]];
  const n = {
    digits: /\d/.test(e),
    lower: /[a-z]/.test(e),
    upper: /[A-Z]/.test(e),
    nonWords: /\W/.test(e)
  };
  let i = 0;
  return Object.values(n).forEach((o) => {
    i += o === !0 ? 1 : 0;
  }), t += (i - 1) * 10, t;
}
function Ft(e, t = !0) {
  if (typeof e == "string" && e) {
    const r = /(?:(?:https?:\/\/)?(?:www\.|(?!www)))([a-zA-Z0-9@]+[a-zA-Z0-9-]\.[^\s<>]{2,})/g;
    return e.replace(r, (i) => {
      let o = i.includes("@") ? "mailto:" : "https://";
      return (i.startsWith("https://") || i.startsWith("mailto:")) && (o = ""), `<a href="${o}${i}" ${t ? 'target="_blank"' : ""} rel="nofollow noreferrer">${i}</a>`;
    });
  }
  return e;
}
function Rt(e, t) {
  return e ? e.indexOf("http") === 0 ? e : `${t || "cdnpath-not-defined/"}${e}` : "";
}
function he(e, t) {
  if (!e)
    return "";
  const r = e.split(".").pop();
  return t.map((i) => `${e}-${i}w.${r} ${i}w`).join(", ");
}
const T = "storedLang";
function we(e) {
  return Array.isArray(e) ? e : e.split(",");
}
function x(e, t) {
  if (t) {
    const r = t.substring(0, 2);
    return e.some((n) => n.startsWith(r)) ? r : void 0;
  }
}
function Ct(e) {
  j() && localStorage.setItem(T, e);
}
function Et(e, t) {
  const r = we(e);
  let n;
  t && x(r, t) ? n = t : j() && localStorage.getItem(T) && (n = x(r, localStorage.getItem(T)));
  const i = x(r, navigator == null ? void 0 : navigator.language);
  return n || i || r[0];
}
function P(e) {
  const [t, r] = e.split(":").map((n) => Number.parseInt(n, 10));
  return { hours: t, minutes: r };
}
function be(e, t) {
  const r = P(t.from), n = P(t.to), i = e.getHours(), o = e.getMinutes();
  return i < r.hours || i === r.hours && o < r.minutes ? "will-open" : i > n.hours || i === n.hours && o > n.minutes ? "closed" : "open";
}
function Y(e = "nl-NL", t = "long") {
  const { format: r } = new Intl.DateTimeFormat(e, { weekday: t });
  return [...Array(7).keys()].map((n) => r(new Date(Date.UTC(2021, 5, n - 1))));
}
function k(e, t) {
  const r = new Date(e);
  r.setHours(0, 0, 0, 0);
  const n = r.getDay(), i = Math.floor(r.getTime() / 1e3);
  return {
    times: t[n],
    exclusions: (t.exclusions || []).find((o) => o.date === i),
    date: r,
    dayOfWeek: n
  };
}
function Ut(e, t = 7, r, n) {
  if (!e)
    return [];
  const i = Y(r, n), o = /* @__PURE__ */ new Date(), s = [];
  for (; s.length < t; ) {
    const a = k(o, e);
    s.push({
      date: a.date,
      day: i[a.dayOfWeek],
      times: a.exclusions ? a.exclusions.times : a.times,
      from_exclusions: !!a.exclusions
    }), o.setDate(o.getDate() + 1);
  }
  return s;
}
function xe(e, t = /* @__PURE__ */ new Date(), r, n) {
  const i = {
    now: {
      status: "closed",
      from: "00:00",
      to: "00:00",
      times: [],
      from_exclusions: !1,
      open_today: !1
    },
    next: void 0
  }, o = k(t, e), s = o.exclusions ? o.exclusions.times : o.times;
  if (i.now.from_exclusions = !!o.exclusions, s) {
    i.now.times = s;
    for (const l of s) {
      const m = new Date(t), c = be(m, l);
      if (["open", "will-open"].includes(c)) {
        i.now.status = c, i.now.from = l.from, i.now.to = l.to, i.now.open_today = !0;
        break;
      }
    }
  }
  const a = Y(r, n);
  function u(l, m = 0) {
    if (m > 10)
      return;
    const c = k(l, e), f = {
      date: c.date,
      dayNr: c.dayOfWeek,
      dayName: a[c.dayOfWeek],
      times: [],
      from_exclusions: !1
    }, y = new Date(l.getTime());
    return y.setDate(y.getDate() + 1), c.exclusions ? c.exclusions.times.length > 0 ? (f.times = c.exclusions.times, f.from_exclusions = !0, f) : u(y, m + 1) : c.times.length > 0 ? (f.times = c.times, f) : u(y, m + 1);
  }
  return t.setDate(t.getDate() + 1), i.next = u(t), i;
}
function D(e, t) {
  return Object.entries(t).reduce((r, [n, i]) => r.replace(`{${n}}`, i), e);
}
function Lt(e, t = void 0, r, n, i) {
  var s;
  if (!e)
    return { text: r.closed, open: !1 };
  const o = xe(e, t, n, i);
  return o.now.status === "will-open" ? {
    text: D(r.willOpenToday, { from: o.now.from }),
    open: !1,
    willOpen: !0
  } : o.now.status === "open" ? {
    text: D(r.open, { to: o.now.to }),
    open: !0,
    willOpen: !0
  } : (s = o.next) != null && s.dayName ? {
    text: D(r.willOpen, { from: o.next.times[0].from, day: o.next.dayName }),
    open: !0,
    willOpen: !0
  } : {
    text: r.closed,
    open: !1,
    willOpen: !1
  };
}
const De = /<img.+?src="(?<src>[^"]+?)".+?\/?>/gi;
function $e(e, t = {}) {
  if (!e || typeof e != "string")
    return "";
  if (!String.prototype.matchAll)
    return e;
  const r = {
    image_alt: "Image",
    image_loading: "lazy",
    image_sizes: [400, 800, 1200, 1900]
  };
  Object.assign(r, t);
  let n = e;
  return [...e.matchAll(De)].forEach((o) => {
    var a, u;
    let s = o[0];
    if (r.image_add_caption && s.includes('alt="')) {
      const l = ((a = s.match(/alt="([^"]+)"/)) == null ? void 0 : a[1]) || "";
      s = `<figure>${s}<figcaption>${l}</figcaption></figure>`;
    } else r.image_alt && !s.includes('alt="') && (s = s.replace("<img", `<img alt="${r.image_alt}"`));
    r.image_loading && !s.includes('loading="') && (s = s.replace("<img", `<img loading="${r.image_loading}"`)), r.image_sizes && !s.includes('srcset="') && ((u = o.groups) != null && u.src) && (s = s.replace("<img", `<img srcset="${he(o.groups.src, r.image_sizes)}"`)), o[0] !== s && (n = n.replace(o[0], s));
  }), n;
}
const ve = /<iframe.+?src="(?<src>https:\/\/(www\.)?youtube\.com\/[^"]+?)".+?\/?>/gi;
function Te(e, t = {}) {
  if (!e || typeof e != "string")
    return "";
  if (!String.prototype.matchAll)
    return e;
  const r = {
    iframe_youtube_title: "Video",
    iframe_youtube_loading: "lazy",
    iframe_youtube_nocookie: !0
  };
  Object.assign(r, t);
  let n = e;
  return [...e.matchAll(ve)].forEach((o) => {
    var a, u;
    let s = o[0];
    r.iframe_youtube_title && !s.includes('title="') && (s = s.replace("<iframe", `<iframe title="${r.iframe_youtube_title}"`)), r.iframe_youtube_loading && !s.includes('loading="') && (s = s.replace("<iframe", `<iframe loading="${r.iframe_youtube_loading}"`)), r.iframe_youtube_nocookie && ((u = (a = o.groups) == null ? void 0 : a.src) != null && u.includes("youtube.com")) && (s = s.replace("youtube.com", "youtube-nocookie.com")), o[0] !== s && (n = n.replace(o[0], s));
  }), n;
}
const ke = /<table\b[^>]*>(.*?)<\/table>/gs;
function _e(e, t = {}) {
  if (!e || typeof e != "string")
    return "";
  if (!String.prototype.matchAll)
    return e;
  const r = {
    table_wrap_class: "table-wrapper"
  };
  Object.assign(r, t);
  let n = e;
  return [...e.matchAll(ke)].forEach((o) => {
    let s = o[0];
    s = `<div class="${r.table_wrap_class}">${s}</div>`, o[0] !== s && (n = n.replace(o[0], s));
  }), n;
}
function Ot(e, t = {}) {
  if (!e || typeof e != "string")
    return "";
  let r = e;
  return r = $e(r, t), r = Te(r, t), r = _e(r, t), r;
}
const Mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  at as ActiveCampaign,
  st as Mailchimp,
  Ue as array_toggleValue,
  Se as awaitArray,
  Rt as cdnUrl,
  Ae as colors_getStepsBetween,
  Le as containsTargetElement,
  bt as contrastText,
  fe as conversionValues,
  xt as convert,
  qe as dateTimeFormats,
  He as dates_getDateFromIntlParts,
  Be as dates_getDateInTimezone,
  Ke as dates_getFirstWeekDayAfter,
  H as dates_getRange,
  Ye as dates_getRangeOverlap,
  ze as dates_getTimestampFromDate,
  ee as dates_getTimestampRange,
  je as dates_getWeekNumber,
  We as dates_minutesToTimeString,
  Ge as dates_sort,
  rt as debounce,
  wt as decodeBase64,
  Ve as docs_createNavigation,
  Xe as docs_createSidebar,
  re as docs_treeToSidebar,
  q as dom_setFocus,
  Dt as embedUrl,
  ht as encodeBase64,
  K as files_createTree,
  Je as files_downloadBlob,
  Qe as files_getFromDrop,
  et as files_getFromInput,
  tt as files_splitFilename,
  ne as files_unHumanizeFilesize,
  $ as files_validateFile,
  ge as firstLetterToUpperCase,
  Me as focusFirstTabIndex,
  Tt as generatePassword,
  nt as generateSitemap,
  Pe as getCSSVarValue,
  Et as getDefaultLang,
  $t as getFirstLetterOfEveryWord,
  we as getLanguages,
  kt as getLocaleText,
  mt as getNumberFormats,
  Fe as groupByObjectValue,
  xe as hours_getNextOpenMoment,
  Lt as hours_getNextOpenMomentMessage,
  Ut as hours_getTimesPerDayForDays,
  it as http_cancelDuplicates,
  ot as http_responseFormat,
  he as imageSizes,
  Ft as linkify,
  ut as maps_getCenter,
  lt as maps_getGoogleMapsLink,
  ct as maps_getStaticMapImage,
  _t as nl2br,
  dt as numbers_getRange,
  ft as numbers_round,
  yt as numbers_roundToClosestFromArray,
  pt as numbers_roundToInt,
  It as replaceBrackets,
  Ot as richtextHtml,
  St as scorePassword,
  Oe as select,
  Re as shuffle,
  Ce as sortBy,
  Ee as sortByArray,
  Ct as storeLanguage,
  vt as string_format,
  gt as strings_addParamsToUrl,
  Nt as strings_replaceDynamicPath,
  Ze as stringtotime,
  j as supportsLocalStorage,
  Mt as types,
  h as validateProps
};
//# sourceMappingURL=services.js.map
